export function assetUrl(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${process.env.PUBLIC_URL || ''}${url}`;
}
